import { DEFAULT_PAGE_SIZE } from "../../constants/pagination";
import { STYLE } from "./actionTypes";

const INIT_STATE = {
  listaStyle: {
    totalRecord: 0,
    records: [],
  },
  loadingStyle: true,
  pageSizeStyle: DEFAULT_PAGE_SIZE,
  isStyleSave: null,
  messageStyle: "",
  listaStyleHistory: [],
  loadingStyleHistory: true,
  style: null,
  errorLoadingStyle: null,
  errorLoadingStyleHistory: null
};

const StyleReducer = (state = INIT_STATE, action) => {
  switch (action.type) {
    case STYLE.GET_LISTA_STYLE.REQUEST:
      return {
        ...state,
        loadingStyle: true,
      };
    case STYLE.GET_LISTA_STYLE.SUCCESS:
      return {
        ...state,
        listaStyle: action.payload,
        loadingStyle: false,
      };
    case STYLE.GET_LISTA_STYLE.FAIL:
      return {
        ...state,
        messageStyle: action.payload,
        loadingStyle: false,
      };
    case STYLE.GET_STYLE.REQUEST:
      return {
        ...state,
        loadingStyle: true,
      };
    case STYLE.GET_STYLE.SUCCESS:
      return {
        ...state,
        loadingStyle: false,
        style: action.payload,
      };
    case STYLE.GET_STYLE.FAIL:
      return {
        ...state,
        messageStyle: action.payload,
        loadingStyle: false,
        errorLoadingStyle: true,
      };
    case STYLE.SAVE_STYLE.REQUEST:
      return {
        ...state,
        loadingStyle: true,
      };
    case STYLE.SAVE_STYLE.SUCCESS:
      return {
        ...state,
        loadingStyle: false,
        isStyleSave: action.payload,
      };
    case STYLE.SAVE_STYLE.FAIL:
      return {
        ...state,
        loadingStyle: false,
        isStyleSave: false,
        messageStyle: action.payload,
      };
    case STYLE.LOAD_EMPTY_STYLE:
      return {
        ...state,
        style: null,
        loadingStyle: false,
        errorLoadingStyle: null,
        errorLoadingStyleHistory: null
      };
    case STYLE.CLEAN_MESSAGE_STYLE:
      return {
        ...state,
        messageStyle: null,
        loadingStyle: false,
        isStyleSave: null,
      };
    case STYLE.CHANGE_PAGE_SIZE_STYLE:
      return {
        ...state,
        pageSizeStyle: action.payload,
      };
    case STYLE.GET_STYLE_HISTORY_LIST.REQUEST:
      return {
        ...state,
        loadingStyleHistory: true,
      };
    case STYLE.GET_STYLE_HISTORY_LIST.SUCCESS:
      return {
        ...state,
        loadingStyleHistory: false,
        listaStyleHistory: action.payload,
      };
    case STYLE.GET_STYLE_HISTORY_LIST.FAIL:
      return {
        ...state,
        loadingStyleHistory: false,
        errorLoadingStyleHistory: true,
      };
    case STYLE.GET_STYLE_HISTORY.REQUEST:
      return {
        ...state,
        loadingStyle: true,
      };
    case STYLE.GET_STYLE_HISTORY.SUCCESS:
      return {
        ...state,
        loadingStyle: false,
        style: action.payload,
      };
    case STYLE.GET_STYLE_HISTORY.FAIL:
      return {
        ...state,
        loadingStyle: false,
        messageStyle: action.payload,
        errorLoadingStyleHistory: true,
      };
    case STYLE.DISABLE_LOADING_STYLE:
      return {
        ...state,
        loadingStyleHistory: false,
        loadingStyle: false,
      };
    default:
      return state;
  }
};

export default StyleReducer;
